import axios from '../axios'

const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE (state, payload) {

    // find item index in search list state
    // eslint-disable-next-line eqeqeq
    const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
    } else {
      // find item index from starred pages
      // eslint-disable-next-line eqeqeq
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp                 = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY (state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR (state, val)   { state.themePrimaryColor = val   },
  UPDATE_THEME (state, val)           { state.theme             = val   },
  UPDATE_WINDOW_WIDTH (state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y (state, val) { state.scrollY           = val   },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      // eslint-disable-next-line eqeqeq
      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },

  ////////////////////////////////////////////////
  // Authentication: login, register, rest password
  ///////////////////////////////////////////////
  SET_TOKEN_TO_LOCALSTORAGE (state, response) {
    localStorage.setItem('token', JSON.stringify(response))
  },
  SET_TOKEN_TO_HEADER_REQUEST (state, response) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${response}`
  },
  SET_USER_DATA (state, userData) {
    state.user = userData
    localStorage.setItem('userInfo', JSON.stringify(userData))
  },
  SET_USER_ROLES (state, userRoles) {
    state.userRoles = userRoles
    localStorage.setItem('userRoles', JSON.stringify(userRoles))
  },
  CLEAR_USER_DATA (state) {
    state.user = null
    localStorage.removeItem('userInfo')
    localStorage.clear()
    axios.defaults.headers.common['Authorization'] = null
    // location.reload()
  },
  SET_USER_IMAGE_CORNER (state, avatar_profile_image) {
    state.userAvatar = avatar_profile_image
  },
  SET_USERS_PDN (state, usersPDN) {
    state.usersPDN = usersPDN
  },
  SET_EMPLOYEES (state, employees) {
    state.employees = employees
  },
  SET_EMPLOYEE (state, employee) {
    state.employee = employee
  },
  ADD_EMPLOYEE (state, item) {
    state.employees.push(item)
  },
  REMOVE_EMPLOYEE (state, itemId) {
    const ItemIndex = state.employees.findIndex((p) => p.id_employee === itemId)
    state.employees.splice(ItemIndex, 1)
  },
  UPDATE_EMPLOYEE (state, employee) {
    const employeesIndex = state.employees.findIndex((p) => p.id_employee === employee.id)
    Object.assign(state.employees[employeesIndex], employee)
  },
  UPDATE_EMPLOYEE_PASSWORD () {
  },
  UPDATE_EMPLOYEE_FLAG_LOGIN () {
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                           /////////////////////////////////////////////////
  //////////////////////////////////////          R O L E S           ////////////////////////////////////////////////
  ///////////////////////////////////////                              ////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_ROLES (state, roles) {
    state.roles = roles
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                           /////////////////////////////////////////////////
  //////////////////////////////////////   D E P A R T A M E N T O S   ////////////////////////////////////////////////
  ///////////////////////////////////////                              ////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_DEPARTMENTS (state, departments) {
    state.departments = departments
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                           /////////////////////////////////////////////////
  //////////////////////////////////////   D E P A R T A M E N T O S   ////////////////////////////////////////////////
  ///////////////////////////////////////                              ////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_HEADQUARTERS (state, headquarters) {
    state.headquarters = headquarters
  },


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     B U S I N E S S    T Y P E S        ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_BUSINESS_TYPE (state, businessTypes) {
    state.businessTypes = businessTypes
  },
  ADD_BUSINESS_TYPE (state, item) {
    state.businessTypes.push(item)
  },
  UPDATE_BUSINESS_TYPE (state, businessType) {
    const businessTypesIndex = state.businessTypes.findIndex((p) => p.id_business_type === businessType.id)
    Object.assign(state.businessTypes[businessTypesIndex], businessType)
  },
  REMOVE_ITEM_BUSINESS_TYPE (state, itemId) {
    const ItemIndex = state.businessTypes.findIndex((p) => p.id_business_type === itemId)
    state.businessTypes.splice(ItemIndex, 1)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     B U S I N E S S    T Y P E S        ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_BUSINESS_SECTOR (state, businessSectors) {
    state.businessSectors = businessSectors
  },
  ADD_BUSINESS_SECTOR (state, item) {
    state.businessSectors.push(item)
  },
  UPDATE_BUSINESS_SECTOR (state, businessSector) {
    const businessSectorsIndex = state.businessSectors.findIndex((p) => p.id_sector === businessSector.id)
    Object.assign(state.businessSectors[businessSectorsIndex], businessSector)
  },
  REMOVE_ITEM_BUSINESS_SECTOR (state, itemId) {
    const ItemIndex = state.businessSectors.findIndex((p) => p.id_sector === itemId)
    state.businessSectors.splice(ItemIndex, 1)
  }, 

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     C L I E N T E S    P D N            ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_CLIENTS_PDN_FROM_ADMIN (state, clientsPDN) {
    state.clientsPDN = clientsPDN
  },
  SET_CLIENTS_ADDED_SERVICES (state, clientsAddedServices) {
    state.clientsAddedServices = clientsAddedServices
  },
  SET_CLIENTS_INMIGRATION (state, clientsInmigration) {
    state.clientsInmigration = clientsInmigration
  },
  ADD_CLIENT_PDN_FROM_ADMIN (state, item) {
    state.clientsPDN.push(item)
  },
  UPDATE_CLIENT_PDN_FROM_ADMIN (state, clientpdn) {
    const clientpdnIndex = state.clientsPDN.findIndex((p) => p.client_id === clientpdn.id)
    Object.assign(state.clientsPDN[clientpdnIndex], clientpdn)
  },
  UPDATE_CLIENT_SERVICE () {
  },
  UPDATE_VISA_TYPE () {
  },
  SET_ARRIVAL_DATE (state, arrivalDate) {
    state.arrivalDate = arrivalDate
  },
  UPDATE_ARRIVAL_DATE () {
  },
  ADD_CONTRACT_FILE () {
  },
  REMOVE_CONTRACT_FILE_INMIGRATION () {
  },
  REMOVE_PLAN_VP () {
  },
  REMOVE_INMIGRATION_SERVICE () {
  },
  UPDATE_CLIENT_PDN_FROM_PERFIL_CLIENTE (state, item) {
    const itemIndex = state.addedServicesForAClient.findIndex((p) => p.id_client === item.id)
    Object.assign(state.addedServicesForAClient[itemIndex], item)
  },
  UPDATE_CLIENT_ROLE (state, role) {
    const clientpdnIndex = state.clientsPDN.findIndex((p) => p.client_id === role.id)
    Object.assign(state.clientsPDN[clientpdnIndex], role)
  },
  //////////////////      C O U N T R I E S     ////////////////// 
  SET_COUNTRIES (state, countries) {
    state.countries = countries
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     P E R F I L    C L I E N T E S      ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_CLIENT_INFO_FOR_PERFIL (state, clientInfo) {
    state.clientInfo = clientInfo
  },
  UPDATE_CLIENT_INFO_FOR_PERFIL (state, clientInfo) {
    Object.assign(state.clientInfo, clientInfo)
  },
  SET_CLIENT_TIMELINE (state, clientTimeline) {
    state.clientTimeline = clientTimeline
  },
  UPDATE_PASSWORD_CLIENT_PDN_FROM_ADMIN () {
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////           PAGOS / PAYMENTS              ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_PAYMENTS (state, payments) {
    state.payments = payments
  },
  SET_PAYMENTS_FOR_A_CLIENT (state, paymentsClient) {
    state.paymentsClient = paymentsClient
  },
  SET_PAYMENTS_FOR_A_CLIENT_NONE_SERVICE (state, paymentsClientNoneService) {
    state.paymentsClientNoneService = paymentsClientNoneService
  },
  ADD_PAYMENT (state, item) {
    state.payments.push(item)
  },
  REMOVE_ITEM_PAYMENT_FOR_A_CLIENT (state, itemId) {
    const ItemIndex = state.paymentsClient.findIndex((p) => p.id_payment === itemId)
    state.paymentsClient.splice(ItemIndex, 1)
  },
  UPDATE_PAYMENT (state, payment) {
    const paymentIndex = state.paymentsClient.findIndex((p) => p.id_payment === payment.id_payment)
    Object.assign(state.paymentsClient[paymentIndex], payment)
  },
  UPDATE_PAYMENT_FORMDATA () {
  },
  UPDATE_APPROVAL_PAYMENT () {
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     P E R F I L    E M P L E A D O      ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_EMPLOYEE_INFO_FOR_PERFIL (state, employeeInfo) {
    state.employeeInfo = employeeInfo
  },
  UPDATE_EMPLOYEE_INFO_FOR_PERFIL (state, employeeInfo) {
    Object.assign(state.employeeInfo, employeeInfo)
  },
  UPDATE_EMPLOYEE_AVATAR () {
  },
  RESEND_EMAIL_VERIFICATION () {
  },
  UPDATE_USERNAME () {
  },
  UPDATE_USER_PASSWORD () {
  },
  UPDATE_MY_PROFILE_IMAGE () {
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////              C I U D A D E S            ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////  
  
  SET_PROVINCES (state, provinces) {
    state.provinces = provinces
  },
  SET_MUNICIPALITIES (state, municipalities) {
    state.municipalities = municipalities
  },
  SET_DISTRICTS (state, districts) {
    state.districts = districts
  },
  SET_NEIGHBORHOODS (state, neighborhoods) {
    state.neighborhoods = neighborhoods
  },
  SET_ITEM_DISTRICT (state, district) {
    state.district = district
  },
  SET_ITEM_NEIGHBORHOOD (state, neighborhood) {
    state.neighborhood = neighborhood
  },
  ADD_DISTRICT (state, item) {
    state.districts.push(item)
  },
  ADD_MUNICIPALITY (state, item) {
    state.municipalities.push(item)
  },
  ADD_NEIGHBORHOOD (state, item) {
    state.neighborhoods.push(item)
  },
  UPDATE_DISTRICT (state, district) {
    const districtsIndex = state.districts.findIndex((p) => p.id_district === district.id)
    Object.assign(state.districts[districtsIndex], district)
  },
  UPDATE_MUNICIPALITY (state, municipality) {
    const municipalitiesIndex = state.municipalities.findIndex((p) => p.id_municipality === municipality.id)
    Object.assign(state.municipalities[municipalitiesIndex], municipality)
  },
  UPDATE_NEIGHBORHOOD (state, neighborhood) {
    const neighborhoodsIndex = state.neighborhoods.findIndex((p) => p.id_neighborhood === neighborhood.id)
    Object.assign(state.neighborhoods[neighborhoodsIndex], neighborhood)
  },
  REMOVE_ITEM_DISTRICT (state, itemId) {
    const ItemIndex = state.districts.findIndex((p) => p.id_district === itemId)
    state.districts.splice(ItemIndex, 1)
  }, 
  REMOVE_ITEM_MUNICIPALITY (state, itemId) {
    const ItemIndex = state.municipalities.findIndex((p) => p.id_municipality === itemId)
    state.municipalities.splice(ItemIndex, 1)
  },
  REMOVE_ITEM_NEIGHBORHOOD (state, itemId) {
    const ItemIndex = state.neighborhoods.findIndex((p) => p.id_neighborhood === itemId)
    state.neighborhoods.splice(ItemIndex, 1)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////            N E G O C I O S              ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_BUSINESSES (state, businesses) {
    state.businesses = businesses
  },
  SET_BUSINESS_INFO_FOR_EDIT (state, businessInfo) {
    state.businessInfo = businessInfo
  },
  SET_BUSINESS_TIMELINE (state, businessTimeline) {
    state.businessTimeline = businessTimeline
  },
  ADD_BUSINESS (state, item) {
    state.businesses.push(item)
  },
  UPDATE_BUSINESS (state, businessInfo) {
    Object.assign(state.businessInfo, businessInfo)
  },
  REMOVE_BUSINESS (state, itemId) {
    const ItemIndex = state.businesses.findIndex((p) => p.id_business === itemId)
    state.businesses.splice(ItemIndex, 1)
  }, 
  REMOVE_ITEM_BUSINESS (state, businessInfo) {
    Object.assign(state.businessInfo, businessInfo)
  }, 

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////        MENSAJES DE CONTACTO             ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_CONTACT_MESSAGES (state, contacts) {
    state.contacts = contacts
  },
  ADD_NEW_CONTACT_MESSAGE (state, item) {
    state.contacts.push(item)
  },
  UPDATE_CONTACT_MESSAGE (state, contact) {
    const contactIndex = state.contacts.findIndex((p) => p.id_contact === contact.id)
    Object.assign(state.contacts[contactIndex], contact)
  },
  REMOVE_ITEM_CONTACT_MESSAGE (state, itemId) {
    const ItemIndex = state.contacts.findIndex((p) => p.id_contact === itemId)
    state.contacts.splice(ItemIndex, 1)
  }, 

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////              DOCUMENTOS                 ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_DOCUMENTS (state, documents) {
    state.documents = documents
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////      SOLICITUDES DE CLIETNES            ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_CLIENT_REQUESTS (state, clientRequests) {
    state.clientRequests = clientRequests
  },
  SET_CLIENT_REQUESTS_FOR_A_CLIENT (state, clientRequestsForAClient) {
    state.clientRequestsForAClient = clientRequestsForAClient
  },
  SET_MY_REQUESTS (state, myRequests) {
    state.myRequests = myRequests
  },
  UPDATE_CLIENT_REQUEST (state, item) {
    const clientRequestsIndex = state.clientRequests.findIndex((p) => p.id_client_request === item.id)
    Object.assign(state.clientRequests[clientRequestsIndex], item)
  },
  UPDATE_CLIENT_REQUEST_PERFIL (state, item) {
    // console.log("mutation1")
    const clientRequestsIndex = state.clientRequestsForAClient.findIndex((p) => p.id_client_request === item.id)
    // console.log("mutation2")
    Object.assign(state.clientRequestsForAClient[clientRequestsIndex], item)
    // console.log("mutation3")
  },
  ADD_CLIENT_REQUEST (state, item) {
    state.clientRequests.push(item)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                      //////////////////////////////////////////////////////
  ////////////////////////////////////////    N O T I F I C A T I O N S  //////////////////////////////////////////////
  ///////////////////////////////////////                        //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_NOTIFICATIONS (state, notifications) {
    state.notifications = notifications
  },
  UPDATE_NOTIFICATIONS (state, item) {
    const notificationIndex = state.notifications.findIndex((p) => p.id_notification === item.id_notification)
    Object.assign(state.notifications[notificationIndex], item)
    // const productIndex = state.formularios.findIndex((p) => p.id == formularios.id)
    // Object.assign(state.notifications, notifications)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////  A S I G N A C I O N  -  A S E S O R E S  //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_ASSIGNED_ADVISORS (state, assignedAdvisors) {
    state.assignedAdvisors = assignedAdvisors
  },
  UPDATE_ASSIGNED_ADVISORS (state, item) {
    if (state.assignedAdvisors.length === 0) {
      return
    }
    const assignedAdvisorsIndex = state.assignedAdvisors.findIndex((p) => p.id_assigned_advisor === item.id)
    Object.assign(state.assignedAdvisors[assignedAdvisorsIndex], item)
  }, 
  // Lista los clientes asignados a un empleado
  SET_ASSIGNED_CLIENTS (state, assignedClients) {
    state.assignedClients = assignedClients
  },
  SET_MY_ADVISOR (state, assignedAdvisor) {
    state.assignedAdvisor = assignedAdvisor
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       TIPOS DE VIDEOLLAMADA               //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VIDEOCALLTYPES_ADMIN (state, videoCallTypesAdmin) {
    state.videoCallTypesAdmin = videoCallTypesAdmin
  },
  ADD_VIDEOCALLTYPES_ADMIN (state, item) {
    state.videoCallTypesAdmin.push(item)
  },
  UPDATE_VIDEOCALLTYPES_ADMIN (state, item) {
    const videoCallTypesAdminIndex = state.videoCallTypesAdmin.findIndex((p) => p.id_video_call_type === item.id)
    Object.assign(state.videoCallTypesAdmin[videoCallTypesAdminIndex], item)
  },
  REMOVE_VIDEOCALLTYPES_ADMIN (state, itemId) {
    const ItemIndex = state.videoCallTypesAdmin.findIndex((p) => p.id_video_call_type === itemId)
    state.videoCallTypesAdmin.splice(ItemIndex, 1)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////             VIDEOLLAMADA                  //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VIDEOCALLS (state, videoCalls) {
    state.videoCalls = videoCalls
  },
  SET_VIDEOCALLS_PER_ADVISOR (state, videoCallsPerAdvisor) {
    state.videoCallsPerAdvisor = videoCallsPerAdvisor
  },
  SET_VIDEOCALLS_PER_CLIENT (state, videoCallsPerClient) {
    state.videoCallsPerClient = videoCallsPerClient
  },
  ADD_VIDEOCALL (state, item) {
    state.videoCalls.push(item)
  },
  UPDATE_VIDEOCALL_BY_ADVISOR (state, item) {
    const videoCallsPerAdvisorIndex = state.videoCallsPerAdvisor.findIndex((p) => p.id_video_call === item.id)
    Object.assign(state.videoCallsPerAdvisor[videoCallsPerAdvisorIndex], item)
  },
  RESET_VIDEOCALLS (state, itemId) {
    const videoCallsIndex = state.videoCalls.findIndex((p) => p.id_video_call === itemId)
    Object.assign(state.videoCalls[videoCallsIndex], itemId)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       SERVICIOS PLANES                   //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_SERVICES (state, services) {
    state.services = services
  },
  UPDATE_SERVICE (state, service) {
    const serviceIndex = state.services.findIndex((p) => p.id_service === service.id)
    Object.assign(state.services[serviceIndex], service)
  },
  ADD_SERVICE (state, item) {
    state.services.push(item)
  },
  SET_FINANCIAL_ANALYSIS_FOR_A_CLIENT (state, financialAnalysesForAClient) {
    state.financialAnalysesForAClient = financialAnalysesForAClient
  },
  REMOVE_FINANCIAL_ANALYSIS (state, itemId) {
    const ItemIndex = state.financialAnalysesForAClient.findIndex((p) => p.id_financial_analysis === itemId[0])
    state.financialAnalysesForAClient.splice(ItemIndex, 1)
  },
  ADD_FINANCIAL_ANALYSIS (state, item) {
    state.financialAnalysesForAClient.push(item)
  },
  SET_ADDED_SERVICES_FOR_A_CLIENT (state, addedServicesForAClient) {
    state.addedServicesForAClient = addedServicesForAClient
  },
  SET_FINANCIAL_ANALYSIS_SUMMARY (state, myFinancialAnalysis) {
    state.myFinancialAnalysis = myFinancialAnalysis
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       SERVICIOS PLANES                   //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_USER_COMMENT_TYPES (state, userCommentTypes) {
    state.userCommentTypes = userCommentTypes
  },
  ADD_USER_COMMENT_TYPE (state, item) {
    state.userCommentTypes.push(item)
  },
  UPDATE_ITEM_USER_COMMENT_TYPE (state, item) {
    const userCommentTypesIndex = state.userCommentTypes.findIndex((p) => p.id_uct === item.id)
    Object.assign(state.userCommentTypes[userCommentTypesIndex], item)
  },
  REMOVE_USER_COMMENT_TYPE (state, itemId) {
    const ItemIndex = state.userCommentTypes.findIndex((p) => p.id_uct === itemId)
    state.userCommentTypes.splice(ItemIndex, 1)
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       SERVICIOS PLANES                   //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_USER_COMMENTS_FOR_A_CLIENT (state, UserCommentsForAClient) {
    state.UserCommentsForAClient = UserCommentsForAClient
  },
  SET_USER_COMMENTS (state, userComments) {
    state.userComments = userComments
  },
  ADD_USER_COMMENT (state, item) {
    state.UserCommentsForAClient.push(item)
    state.userComments.push(item)
  },
  UPDATE_ITEM_USER_COMMENT (state, item) {
    if (state.UserCommentsForAClient.length > 0) {
      const UserCommentsForAClientIndex = state.UserCommentsForAClient.findIndex((p) => p.id_uc === item.id)
      Object.assign(state.UserCommentsForAClient[UserCommentsForAClientIndex], item)
    } else if (state.userComments.length > 0) {
      const userCommentsIndex = state.userComments.findIndex((p) => p.id_uc === item.id)
      Object.assign(state.userComments[userCommentsIndex], item)
    }
  },
  REMOVE_USER_COMMENT (state, itemId) {
    if (state.UserCommentsForAClient.length > 0) {
      const ItemIndex = state.UserCommentsForAClient.findIndex((p) => p.id_uc === itemId)
      state.UserCommentsForAClient.splice(ItemIndex, 1)
    }
    if (state.userComments.length > 0) {
      const ItemIndex = state.userComments.findIndex((p) => p.id_uc === itemId)
      state.userComments.splice(ItemIndex, 1)
    }
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA TYPES                           //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VISA_TYPES (state, visaTypes) {
    state.visaTypes = visaTypes
  },
  ADD_ITEM_VISA_TYPE (state, item) {
    state.visaTypes.push(item)
  },
  UPDATE_ITEM_VISA_TYPE_FOR_A_CLIENT () {
  },
  UPDATE_ITEM_VISA_TYPE (state, item) {
    const visaTypesIndex = state.visaTypes.findIndex((p) => p.id_visa_type === item.id)
    Object.assign(state.visaTypes[visaTypesIndex], item)
  },
  SET_CLIENTS_ADDED_SERVICES_INMIGRATION (state, addedServicesForAClientInmigration) {
    state.addedServicesForAClientInmigration = addedServicesForAClientInmigration
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       FAMILY                              //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_CLIENT_FAMILY (state, clientFamily) {
    state.clientFamily = clientFamily
  },
  SET_FAMILY_TYPES (state, familyTypes) {
    state.familyTypes = familyTypes
  },
  ADD_FAMILY (state, item) {
    state.clientFamily.push(item)
  },
  UPDATE_FAMILY (state, item) {
    const clientFamilyIndex = state.clientFamily.findIndex((p) => p.id_family === item.id_family)
    Object.assign(state.clientFamily[clientFamilyIndex], item)
  },
  REMOVE_FAMILY (state, itemId) {
    const ItemIndex = state.clientFamily.findIndex((p) => p.id_family === itemId)
    state.clientFamily.splice(ItemIndex, 1)
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA DOCUMENT                           //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VISA_DOCUMENT_TYPES (state, visaDocumentTypes) {
    state.visaDocumentTypes = visaDocumentTypes
  },
  ADD_ITEM_VISA_DOCUMENT_TYPE (state, item) {
    state.visaDocumentTypes.push(item)
  },
  UPDATE_ITEM_VISA_DOCUMENT_TYPE (state, item) {
    const visaDocumentTypesIndex = state.visaDocumentTypes.findIndex((p) => p.id_visa_document_type === item.id)
    Object.assign(state.visaDocumentTypes[visaDocumentTypesIndex], item)
  },
  REMOVE_ITEM_VISA_DOCUMENT_TYPE () {
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA REQUIREMENT                       //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VISA_REQUIREMENTS_FOR_A_CLIENT (state, visaRequirements) {
    state.visaRequirements = visaRequirements
  },
  SET_ADDED_SERVICE_FOR_A_CLIENT_INMIGRATION (state, addedServicesForAClientInmigrationActive) {
    state.addedServicesForAClientInmigrationActive = addedServicesForAClientInmigrationActive
  },
  ADD_ITEM_VISA_REQUIREMENT_FOR_A_CLIENT (state, item) {
    state.visaRequirements.push(item)
  }, 
  UPDATE_STATUS_ITEM_VISA_REQUIREMENT () {
  },
  UPLOAD_FILE_VISA_REQUIREMENT () {
  },
  REMOVE_FILE_VISA_REQUIREMENT () {
  },
  REMOVE_VISA_REQUIREMENT () {
  },
  UPDATE_ITEM_VISA_REQUIREMENT () {
  },
  UPDATE_ITEM_METADATA_VISA_REQUIREMENT () {
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA STEPS                          //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VISA_STEPS_FOR_A_CLIENT (state, visaStepsForAClient) {
    state.visaStepsForAClient = visaStepsForAClient
  },
  ADD_ITEM_VISA_STEP_TYPE_FOR_A_CLIENT (state, item) {
    state.visaStepsForAClient.push(item)
  }, 
  UPDATE_ITEM_DATA_VISA_STEP () {
  },
  UPDATE_STATUS_ITEM_VISA_STEP () {
  }, 
  DELETE_ITEM_VISA_STEP () {
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA STEPS TYPES                    //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_VISA_STEP_TYPES (state, visaStepTypes) {
    state.visaStepTypes = visaStepTypes
  },
  ADD_ITEM_VISA_STEP_TYPE (state, item) {
    state.visaStepTypes.push(item)
  }, 
  UPDATE_ITEM_VISA_STEP_TYPE () {
  },
  DELETE_ITEM_VISA_STEP_TYPE (state, itemId) {
    const ItemIndex = state.visaStepTypes.findIndex((p) => p.id_visa_step_type === itemId)
    state.visaStepTypes.splice(ItemIndex, 1)
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       STATISTICS                    //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_TOTAL_CLIENTS_BY_PLAN (state, totalClientsByPlan) {
    state.totalClientsByPlan = totalClientsByPlan
  }, 
  SET_INMIGRATONS_CLIENTS (state, inmigrationClients) {
    state.inmigrationClients = inmigrationClients
  }, 
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       CALENDAR                    //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ADD_EVENT (state, event) {
    state.events.push(event)
  },
  SET_EVENTS (state, events) {
    state.events = events
  },
  SET_LABELS (state, labels) {
    state.eventLabels = labels
  },
  UPDATE_EVENT (state, event) {
    const eventIndex = state.events.findIndex((e) => e.id_calendar === event.id)
    Object.assign(state.events[eventIndex], event)
  },
  REMOVE_EVENT (state, eventId) {
    const eventIndex = state.events.findIndex((e) => e.id_calendar === eventId)
    state.events.splice(eventIndex, 1)
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////                 EMAIL                     //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SEND_WELCOME_EMAIL () {
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       MONDAY LINKS                            //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SET_MONDAY_LINKS (state, mondayLinks) {
    state.mondayLinks = mondayLinks
  },
  EDIT_MONDAY_LINK () {
  }
}

export default mutations

